module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAADCAYAAACTWi8uAAAAOklEQVQImWP8EyHfxsDAUMLAwMDKQBn4wsDAkA4y8CcDAwMbhYbBwH4mBgaGXgYGht9UMOwLAwPDHABpAAobgpgRrQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme_yellow/minus2.png
// module id = 5JD3
// module chunks = 1